import { Tuple } from "../../utils/tuple";

// TYPE DEFS
export const ALL_SIMON_SAYS_COLORS = Tuple('red', 'blue', 'yellow', 'green');
export type SimonColor = typeof ALL_SIMON_SAYS_COLORS[number];

export type SimonColorMap = { [Color in SimonColor]: SimonColor };
